import { TicketService } from '@/entities/ticket/api/service';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useCampaignStore } from './campaignStore';

const log = console.log.bind(console, '[useCheckCampaignAchieved]:');

export const useCheckCampaignAchieved = () => {
	const { data: paidTickets } = useQuery({
		queryFn: TicketService.getPaid,
		queryKey: [TicketService.getPaid.queryKey],
	});

	const { setIsCampaignGoalAchieved, isCampaignGoalAchieved } = useCampaignStore();

	useEffect(() => {
		log('Checking if campaignGoalAchieved');

		if (!paidTickets || isCampaignGoalAchieved) {
			log('Either paid tickets are null or goal achieved.');

			return;
		}

		if (paidTickets.length > 0) {
			log('Campaign goal achieved');
			setIsCampaignGoalAchieved(true);
		}
	}, [paidTickets]);
};
